<template>
  <div class="footer">
    <div class="footer-box">
      <div class="logo-box">
        <img src="../assets/logo.png" class="logo-1" />
        <div class="list">
          <p @click="selectMenu(1)">首頁</p>
          <p @click="selectMenu(2)">關於我們</p>
          <p @click="selectMenu(3)">產品與服務</p>
          <p @click="selectMenu(4)">聯絡我們</p>
        </div>
      </div>
      <div class="tel-box">
        <div class="right">
          <div class="tel">聯繫方式</div>
          <div class="telNumber">96742067</div>
          <div class="address">ROOM 4, 16/F, HO KING COMMERCIAL CENTRE, 2-16 FAYUEN STREET, MONGKOK KOWLOON, HONG KONG</div>
        </div>
        <div class="left">
          <div class="email">郵箱</div>
          <div class="emailNumber">leachidatechlmt@gmail.com</div>
        </div>
      </div>
      <div class="copyright">
        Copyright © 2023.FAHMAI MONEY COMPANY LIMITED PTE. LTD.All Rights Reserved.
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.footer {
  .footer-top {
    padding: 0 360px;
    height: 80px;
    line-height: 80px;
    background-color: #212121;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;

      img {
        width: 40px;
        height: 40px;
        vertical-align: middle;
        margin-right: 12px;
      }
    }
  }

  .footer-box {
    padding-bottom: 20px;
    background: #353535;

    .br {
      width: 60px;
      height: 2px;
      background-color: #504f4f;
      margin: 24px 0;
    }

    .logo-box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      padding: 40px 360px;
      border-bottom: 1px solid;
      border-image: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.46)) 1 1;
      box-sizing: border-box;

      .list {
        display: flex;

        p {
          cursor: pointer;
          margin-right: 80px;
          font-size: 20px;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }

      .logo-1 {
        width: 300px;
        height: 28px;
      }

      .text {}
    }
  }

  .tel-box {
    display: flex;
    justify-content: space-between;
    padding: 24px 360px;
    border-bottom: 1px solid;
    border-image: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.46)) 1 1;
    box-sizing: border-box;

    .right {
      .tel {
        margin-bottom: 22px;
        font-size: 20px;
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        color: #FFFFFF;
      }

      .telNumber {
        margin-bottom: 8px;
        font-size: 20px;
        font-family: PingFang TC, PingFang TC;
        font-weight: 500;
        color: #FFFFFF
      }

      .address {
        font-size: 18px;
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .left {

      .email {
        margin-bottom: 22px;
        font-size: 20px;
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        color: #FFFFFF;
      }

      .emailNumber {
        font-size: 20px;
        font-family: PingFang TC, PingFang TC;
        font-weight: 500;
        color: #FFFFFF;
      }
    }
  }

  .copyright {
    margin-top: 17px;
    text-align: center;
    font-size: 14px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "business" });
          break;
        case 3:
          this.$router.push({ path: "privacy" });
          break;
        case 4:
          this.$router.push({ path: "aboutUs" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
